import { render, staticRenderFns } from "./AssetsScadaView.vue?vue&type=template&id=e64bf29a&scoped=true"
import script from "./AssetsScadaView.vue?vue&type=script&lang=js"
export * from "./AssetsScadaView.vue?vue&type=script&lang=js"
import style0 from "./AssetsScadaView.vue?vue&type=style&index=0&id=e64bf29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64bf29a",
  null
  
)

export default component.exports